import "./styles.css";
import { useEditOnboarding } from "../../hooks/useEditOnboarding";
import { Card } from "../Card/Index";
import ChipPressableComponent from "../Chips/ComponentChipPressable/Index";
import ComponentInputSearch from "../InputSearch";
import Pagination from "../Pagination";
import { useFilter } from "../../hooks/useFilter";
import { ReactNode, useEffect, useState } from "react";
import { AnimalCategory } from "../../pages/Onboarding/Register/AnimalCategory/Index";
import { CreateBirthGoals } from "../../pages/Onboarding/Register/CreateBirthGoals/Index";
import { CreateDeathGoals } from "../../pages/Onboarding/Register/CreateDeathGoals/Index";
import { Loading } from "../Loading/Index";
import { DateModal } from "../Modal/DateFilter";
import { formatDateWithoutHour } from "../../utils/date/formatedDate";
import { IOptionsProps } from "../../@types/reactSelect/IOption";
import { DropdownMultiSelect } from "../Filters/DropDownMultiSelect/Index";
import { useTaskCreation } from "../../hooks/useTaskCreation";
import { WeightAnimals } from "../Onboarding/CattleMap/WeightAnimals";

export function ViewCards() {
  const {
    filterSelected,
    setFilterSelected,
    listCards,
    setOptionForm,
    totalPages,
    currentPage,
    setIdSelected,
    setFarmIdSelected,
    setCardInfo,
    setDefaultValue,
    setCurrentPage,
    setQueryToSearch,
    isLoading
  } = useEditOnboarding();

  const { sideBarOptionSelected, rangeDays, setRangeDays, setModalInventoryTaskStop } = useFilter();
  const { allFarms } = useTaskCreation()
  const [farmOptions, setFarmOptions] = useState<IOptionsProps>();
  const [customComponent, setCustomComponent] = useState<ReactNode | undefined>(undefined);
  const optionsWithoutSearch = ["animal-category", "goals-birth", "goals-death", "pasture-management", "batch-inventory", "weight-animals"];
  const optionsWithFarmSelect = ["batch-inventory"];
  const customColorCard = ["batch-inventory"];

  useEffect(() => {
    if (filterSelected == "batch-inventory") {
      const now = new Date();
      const lastYear = new Date(now.getFullYear() - 1, now.getMonth(), now.getDay());

      setRangeDays({
        from: lastYear,
        to: now
      })
    }
  }, []);

  useEffect(() => {
    setFarmOptions(allFarms?.map(farm => ({
      label: farm.name,
      value: farm.id,
      info: farm
    })))
  }, [allFarms]);

  useEffect(() => {
    switch (filterSelected) {
      case "animal-category":
        setCustomComponent(() => <AnimalCategory onlyRead />);
        break;
      case "goals-birth":
        setCustomComponent(() => <CreateBirthGoals onlyRead />);
        break;
      case "goals-death":
        setCustomComponent(() => <CreateDeathGoals onlyRead />);
        break;
      case "weight-animals":
        setCustomComponent(() => <WeightAnimals />);
        break;
      case "pasture-management":
        break;
      default:
        if (sideBarOptionSelected !== 'PROFILES') {
          setCustomComponent(() => undefined);
        }
        break;
    }
  }, [filterSelected]);

  const { systemManager } = useFilter();

  const OptionsMap = new Map();
  OptionsMap.set("farms", "Agropecuária ou Fazenda");
  OptionsMap.set("areas", "Retiro");
  OptionsMap.set("micro-areas", "Pasto");
  OptionsMap.set("batches", "Lote");

  function formatDefaultValuesPasteureManagement(data: any) {
    return {
      id: data.id,
      microAreas: data.info.micro_area.map((microArea: any) => (
        {
          label: `${microArea.farm.initials}-${microArea.area.initials}-${microArea.initials}`,
          value: microArea.id,
          info: microArea
        }
      )),
      type: {
        label: data.managementType.type.name,
        value: data.managementType.type.id
      },
      monitor: {
        label: data.managementType.type.monitoring_types[0].name,
        value: data.managementType.type.monitoring_types[0].id
      },
      frequency: data.info.frequency,
      days_of_week: data.info.days_of_week,
      execution_per_day: data.info.execution_per_day,
      start_date: data.info.start_date,
      requirement_in: data.info.requirement_in,
      requirement_out: data.info.requirement_out,
      farm: data.info.micro_area[0].farm,
      area: data.info.micro_area[0].area
    }
  }

  const showFarmName = ["pasture-management"]
  const showAreaName = ["pasture-management"]

  const inventoryColorsMap = new Map()
  inventoryColorsMap.set("DRAFT", "#ff9501af")
  inventoryColorsMap.set("PENDING", "#0157ffaf")
  inventoryColorsMap.set("COMPLETED", "#62b8aeaf")

  return (
    <>
      {/* Filtro */}
      <div className="filter__content">
        {systemManager == "PROPERTIES_AREAS" && (
          <>
            <ChipPressableComponent
              theme={filterSelected == "farms" ? "menu-dark" : "menu-light"}
              label={"Agropecuária ou Fazenda"}
              onClick={() => setFilterSelected("farms")}
            />
            <ChipPressableComponent
              theme={filterSelected == "areas" ? "menu-dark" : "menu-light"}
              label={"Retiro"}
              onClick={() => setFilterSelected("areas")}
            />
            <ChipPressableComponent
              theme={
                filterSelected == "micro-areas" ? "menu-dark" : "menu-light"
              }
              label={"Pasto"}
              onClick={() => setFilterSelected("micro-areas")}
            />
          </>
        )}

        {systemManager == "CREATE_BATCH" && (
          <>
            <ChipPressableComponent
              theme={filterSelected == "batches" ? "menu-dark" : "menu-light"}
              label={"Lote"}
              onClick={() => setFilterSelected("batches")}
            />
          </>
        )}

        {systemManager == "CATTLE_MAP" && (
          <>
            <ChipPressableComponent
              theme={filterSelected == "animal-category" ? "menu-dark" : "menu-light"}
              label={"Categoria Animal"}
              onClick={() => setFilterSelected("animal-category")}
            />
            <ChipPressableComponent
              theme={filterSelected == "weight-animals" ? "menu-dark" : "menu-light"}
              label={"Pesos"}
              onClick={() => setFilterSelected("weight-animals")}
            />
            <ChipPressableComponent
              theme={filterSelected == "goals-birth" ? "menu-dark" : "menu-light"}
              label={"Meta de Nascimento"}
              onClick={() => setFilterSelected("goals-birth")}
            />
            <ChipPressableComponent
              theme={filterSelected == "goals-death" ? "menu-dark" : "menu-light"}
              label={"Meta de Morte"}
              onClick={() => setFilterSelected("goals-death")}
            />
          </>
        )}

        {filterSelected && !optionsWithoutSearch.includes(filterSelected) &&
          <>
            <div style={{ width: "100%" }}>
              <ComponentInputSearch
                type={OptionsMap.get(filterSelected)}
                onClick={(query: string | undefined) => setQueryToSearch(query)}
              />
            </div>
          </>
        }

        {filterSelected && optionsWithFarmSelect.includes(filterSelected) &&
          <>
            <div className="filters-dropdown" style={{ width: 400 }}>
              <DropdownMultiSelect
                options={farmOptions || []}
                getSelectedData={(data: any) => setFarmIdSelected(data.value)}
                defaultValue={farmOptions ? farmOptions[0] : undefined}
                placeholder={'Selecione a fazenda'}
                closeMenuOnSelect
                menuFloat
              />
            </div>
          </>
        }
      </div>
      {/* Filtro */}

      {!!customComponent ?
        <div className="children__content">
          {customComponent}
        </div>
        :
        <>
          {/* Visualização dos cards */}
          {listCards.length > 0 ?
            <section className="grid__infos">
              <Loading visible={isLoading} />

              {filterSelected && listCards.map((card) => {
                function getCardBackgroundColor(card: any) {
                  if (card.state === "PENDING") return "#0157ffaf";
                  if (card.state === "DRAFT") return "#ff9501af";
                  if (filterSelected && card.date && rangeDays?.from) {
                    const cardDate = new Date(card.date);
                    const fromDate = new Date(rangeDays.from);
                    return cardDate > fromDate
                      ? inventoryColorsMap.get(card.state)
                      : "#ff6161af";
                  }
                  return "#ff6161af";
                }

                function verifyCompletedInDate(card: any) {
                  if (card.date && rangeDays?.from) {
                    return new Date(card.date) < new Date(rangeDays.from);
                  }
                  return false;
                }

                function disabledEdit(card: any) {
                  if (card.state === "COMPLETED" && verifyCompletedInDate(card)) return false;
                  return true
                }

                return (
                  <Card
                    type={filterSelected}
                    initials={card.initial}
                    name={card.name}
                    qtdArea={card.qtdArea}
                    qtdMicroArea={card.qtdMicroArea}
                    qtdAnimals={card.qtdAnimals}
                    initialBatch={card.initialBatch}
                    onClick={() => {
                      setIdSelected(card.id);
                      if (filterSelected == "areas" || filterSelected == "pasture-management" || filterSelected == "batch-inventory") setOptionForm(filterSelected)
                      if (filterSelected === "batch-inventory") {
                        const isDraft = !disabledEdit(card);
                        setModalInventoryTaskStop(isDraft);
                        const formatedCard = isDraft
                          ? { ...card, state: undefined, id: null }
                          : card;
                        setCardInfo(formatedCard);
                      }
                      if (filterSelected == "pasture-management") setDefaultValue(formatDefaultValuesPasteureManagement(card))
                    }}
                    managementType={card.managementType}
                    showFarm={showFarmName.includes(filterSelected)}
                    showArea={showAreaName.includes(filterSelected)}
                    nameFarm={card.info && card.info.micro_area! ? card.info.micro_area[0].farm.name : null}
                    nameArea={card.info && card.info.micro_area! ? card.info.micro_area[0].area.name : null}
                    listInitialsMicroAreas={card.info && card.info.micro_area! && card.info.micro_area.map((mc: any) => mc.initials)}
                    date={card.date ? formatDateWithoutHour(new Date(card.date)) : undefined}
                    style={
                      customColorCard.includes(filterSelected) ? {
                        backgroundColor: getCardBackgroundColor(card),
                      } : undefined
                    }
                    description={card.description}
                    state={!disabledEdit(card) ? "DRAFT" : card.state}
                  />
                );
              })}
            </section>
            : <div className="emptyTable_container">
              <span>Nenhum resultado encontrado.</span>
            </div>
          }
          {/* Visualização dos cards */}

          {/* Paginação */}
          {
            listCards.length ?
              <>
                <div className="delimiter" style={{ marginTop: 30, marginBottom: 20 }} />
                <div className="paginator">

                  {filterSelected == "batch-inventory" &&
                    <div className={"gridSubtitleContainer"}>
                      <div className={"gridSubtitle"} style={{ background: "#ff6161af" }}>
                        Não realizado
                      </div>
                      <div className={"gridSubtitle"} style={{ background: "#ff9501af" }}>
                        Em preenchimento
                      </div>
                      <div className={"gridSubtitle"} style={{ background: "#0157ffaf" }} >
                        Enviado para capataz
                      </div>
                      <div className={"gridSubtitle"} style={{ background: "#62b8aeaf" }}>
                        Concluído
                      </div>
                    </div>
                  }

                  <Pagination
                    totalPages={totalPages}
                    currentPage={currentPage}
                    onClick={(value: number) => setCurrentPage(value)}
                  />
                </div>
              </>
              : <></>
          }
          {/* Paginação */}
        </>
      }

      {/* Modals*/}
      <DateModal />
      {/* Modals */}
    </>
  );
}
